
import Vue from "vue";
import { Purchase } from "@/models/base";
import AppSelectJournal from "../SelectJournal.vue";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";
import { PurchaseService } from "@/services/purchase-service";
import { HttpError } from "@/utils/services/http-error";
import { DossierConfigService } from "@/services/dossier-config-service";
import {isValidOGM,generateOGM} from "@/utils/ogm";
import AppCurrencySelect from "@/components/CurrencySelect.vue";
import {CurrencyService} from "@/services/currency-service";
import Currency from "@/models/base/currency";

export default Vue.extend({
	data(){
		return {
			PaymentBeforeDiscountAmount: 0
		};
	},
	props: {
		value: {
			type: Object as () => Purchase,
			required: true
		},
	},
	computed: {
		hasJournalModule():boolean {
			return AuthService.hasModule(MODULE.TOT_99_JOURNALEN);
		},
		isAllowedMultiValuta(): boolean {
			return AuthService.hasModule(10);
		},
		currencyRate(): number {
			if(this.value.ID==0){
				let currencies = CurrencyService.getCurrencies();
				if (currencies.length == 0){
					return 1;
				}
				let foundCurrency = currencies.filter((c:Currency) => c.ID == this.value.CurrencyID)[0];
				if (!foundCurrency) return 1;
				return foundCurrency.Rate || 1;
			}
			return this.value.CurrencyRate;
		}
	},
	watch: {
		"value.ContactID": {
			handler(){
				this.changeSettings();
				this.checkInvoiceExists();
			}
		}
	},
	methods: {
		onVatYearInfoClick(){
			window.open("https://btwjaar.winfakt.help/", "_blank");
		},
		changeSettings() {
			this.value.VatPeriod = this.value.InvoiceDate.getMonth() + 1;
			this.value.VatYear = this.value.InvoiceDate.getFullYear();
			this.value.setExpirationDateFromContact();
			this.setAccountingPeriod();
		},
		onPaymentBeforeDiscountPercentageChange(){
			this.PaymentBeforeDiscountAmount =
				(((this.value.VATPurchaseTradingGoods+this.value.VATServicesAndCosts+this.value.VATBuisinessAssets)/100)*this.value.DiscountPercantage);
		},
		onPaymentBeforeDiscountAmountChange(){
			this.$emit("update-payment-percentage", this.PaymentBeforeDiscountAmount);
		},
		setAccountingPeriod(){
			this.value.VatPeriod = this.value.InvoiceDate.getMonth() + 1;
			this.value.VatYear = this.value.InvoiceDate.getFullYear();
			let bookYearStartMonth = DossierConfigService.getGeneralConfig().BookYearStartMonth;
			this.value.AccountingPeriod = this.value.InvoiceDate.getMonth() + 1 - bookYearStartMonth;
			if (this.value.AccountingPeriod < 1){
				this.value.AccountingPeriod += 12;
			}
		},

		async checkInvoiceExists(){
			if (this.value.ContactID == 0) return;
			if (!this.value.InvoiceNR) return;
			try{
				let res = await PurchaseService.findByInvoiceAndContactId(this.value.InvoiceNR, this.value.ContactID);
				if (res.ID != this.value.ID){
					this.$wf.dialog(this.$ct("there-is-already-a-purchase-with-this-id"), this.$ct("common.ok"), this.$ct("common.warning"));
				}
			}catch(err){
				let e = err as HttpError;
				if (e.status == 404){
					e.dontShow = true;
				}
			}
		},
		checkOgm(){
			if(this.value.Communication.length == 12){
				if(isValidOGM(this.value.Communication)){
					this.value.Communication = generateOGM(this.value.Communication);
				}
			}
		},
		toggleType(){
			this.value.IsCreditNote = this.value.Total < 0;
		},
	},
	mounted() {
		if (this.value.ID != 0) return;
		this.value.VatPeriod = this.value.InvoiceDate.getMonth() + 1;
		this.value.VatYear = this.value.InvoiceDate.getFullYear();
		this.setAccountingPeriod();
		if (this.value.InboxreaderPurchaseID != 0) return;
		this.value.ExpirationDate = new Date(this.value.InvoiceDate.getTime());
		this.value.ExpirationDate.setDate(this.value.ExpirationDate.getDate() + 30);
	},
	created(){
		this.value.CurrencyRate = this.currencyRate;
		this.PaymentBeforeDiscountAmount =
			(((this.value.VATPurchaseTradingGoods+this.value.VATServicesAndCosts+this.value.VATBuisinessAssets)/100)*this.value.DiscountPercantage);
	},
	components: {
		AppSelectJournal,
		AppCurrencySelect
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
